export class SecurityKodDto {
    userId: number;
    securityKod:string;
    ticketId: number
}